import * as React from "react";
import { forwardRef } from "react";
const SvgToDo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Property 1=24" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M12 20.1152C7.59 20.1152 4 16.5252 4 12.1152C4 7.70523 7.59 4.11523 12 4.11523C16.41 4.11523 20 7.70523 20 12.1152C20 16.5252 16.41 20.1152 12 20.1152Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgToDo);
export default ForwardRef;
